import React, { Children } from 'react';
import { Grid } from '@mui/material';
import { InfoCardListProps, infoCardListStyles } from './info-card-list-helper';

export const InfoCardList = ({
    children,
}: InfoCardListProps): React.JSX.Element => {
    return (
        <Grid
            container
            item
            xs={12}
            md={12}
            spacing={3.5}
            sx={infoCardListStyles.containerGrid}
        >
            {Children.map(children, (child, index) => (
                <Grid
                    item
                    xs={12}
                    md={12 / Children.count(children)}
                    sx={infoCardListStyles.childGrid}
                    key={`${index}_of_${Children.count(children)}`}
                >
                    {child}
                </Grid>
            ))}
        </Grid>
    );
};
